
import "./TestStyles.css";
import React, { useState, useEffect, useCallback } from "react";
import { handleOnPopState } from '../utils/pop_state_utils.js';
import { useNavigate, useLocation } from "react-router-dom";
import { uploadJsonAndSubmitAutonocog } from '../utils//json_utils.js';
import { calculate_progress } from "../utils/progress_bar.js";
import { UpdateLocalStorage } from '../db/localstorage_utils.js';
import { playInstructionsOnce, handleAudioEndedCommon } from '../utils/audio_utils.js';
import DropDownComponent from "./DropDownComponent";

const QuestionTwentyScreen = ({ userData }) => {
  const [audio] = useState(new Audio("/audio/q20_instructions.mp3"));
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [nextButtonStyle, setNextButtonStyle] = useState("NextButton");
  const [audioPlayed, setAudioPlayed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const results = JSON.parse(localStorage.getItem("results"));
  const [nextPage] = useState("/ThanksScreen");        // Where this screen will navigate to next
  const [thisPage] = useState("screen_20");  
  const handleAudioEnded = useCallback(() => {
    handleAudioEndedCommon({
      audio,
      onEnded: handleAudioEnded,
      setAudioPlayed,
      setButtonDisabled,
      setNextButtonStyle
    });
  }, [audio]);

   
  // Implementing the popstate handler
  window.onpopstate = () => {
      handleOnPopState({ results, userData, navigate, location });
    };

  useEffect(() => {   // Instructions effect
      if (!audioPlayed) {
        playInstructionsOnce({ audio, audioPlayed, setAudioPlayed, onEnded: handleAudioEnded });
      }
    }, [audio, audioPlayed, handleAudioEnded]); 

  const firstNameDropdown = [
    { value: "Henry", label: "Henry" },
    { value: "Harry", label: "Harry" },
    { value: "Emery", label: "Emery" },
    { value: "Justin", label: "Justin" },
  ];

  const lastNameDropdown = [
    { value: "Davidson", label: "Davidson" },
    { value: "Trudeau", label: "Trudeau" },
    { value: "Howard", label: "Howard" },
    { value: "Barnes", label: "Barnes" },
  ];

  const addressNumDropdown = [
    { value: "37", label: "37" },
    { value: "23", label: "23" },
    { value: "73", label: "73" },
    { value: "42", label: "42" },
  ];

  const addressFirstNameDropdown = [
    { value: "Orchard", label: "Orchard" },
    { value: "Rose", label: "Rose" },
    { value: "Blossom", label: "Blossom" },
    { value: "Violet", label: "Violet" },
  ];

  const addressLastNameDropdown = [
    { value: "Close", label: "Close" },
    { value: "Way", label: "Way" },
    { value: "Bay", label: "Bay" },
    { value: "Street", label: "Street" },
  ];

  const cityNameDropdown = [
    { value: "Cambridge", label: "Cambridge" },
    { value: "London", label: "London" },
    { value: "Kingsbridge", label: "Kingsbridge" },
    { value: "Dartmouth", label: "Dartmouth" },
  ];

  const regionDropdown = [
    { value: "Devon", label: "Devon" },
    { value: "Ontario", label: "Ontario" },
    { value: "Alberta", label: "Alberta" },
    { value: "Texas", label: "Texas" },
  ]

  return (
    <div className="Container">
      <div className="InstructionsContainer">
        <img className="CharacterIcon" src="/icons/other.png" alt="Character Icon" />
        <progress variant="custom" className="ProgressBar" value={calculate_progress('asymptotic', 54, 54)} max="1"></progress>
        <p className="Instructions">Please select the address below.</p>
        <DropDownComponent placeholder="First name" options={firstNameDropdown} className="firstName-dropdown" />
        <DropDownComponent placeholder="Last name" options={lastNameDropdown} className="lastName-dropdown" />
        <DropDownComponent placeholder="Address number" options={addressNumDropdown} className="addressNum-dropdown" />
        <DropDownComponent
          placeholder="Address first name"
          options={addressFirstNameDropdown}
          className="addressFirstName-dropdown"
        />
        <DropDownComponent
          placeholder="Address last name"
          options={addressLastNameDropdown}
          className="addressLastName-dropdown"
        />
        <DropDownComponent placeholder="City name" options={cityNameDropdown} className="cityName-dropdown" />
        <DropDownComponent placeholder="Region name" options={regionDropdown} className="regionName-dropdown" />
      </div>
      <div className="NextButtonContainer">
        <button disabled={buttonDisabled} onClick={async () => {
          const screenData = {
              first_name: localStorage.getItem("firstName-dropdown"),
              last_name: localStorage.getItem("lastName-dropdown"),
              address_number: localStorage.getItem("addressNum-dropdown"),
              address_first_name: localStorage.getItem("addressFirstName-dropdown"),
              address_last_name: localStorage.getItem("addressLastName-dropdown"),
              city_name: localStorage.getItem("cityName-dropdown"),
              region_name: localStorage.getItem("regionName-dropdown"),
            };          
          UpdateLocalStorage(screenData, thisPage)
          uploadJsonAndSubmitAutonocog({ userData });
          navigate(nextPage);
        }} className={nextButtonStyle}>
          <img src="/icons/arrow.png" alt="Next Button" />
        </button>
      </div>
    </div>
  );
};

export default QuestionTwentyScreen;
